<h2 mat-dialog-title class="pud-title">Upload portfolio</h2>

<div mat-dialog-content class="pud-content">
  <input
    hidden
    type="file"
    accept=".xlsx"
    #fileInput
    (change)="onFileBrowse(fileInput)"
  />

  <div class="pud-dropzone" appDnd (fileDropped)="onFileDropped($event)">
    <svg class="pud-dropzone-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 16V4m0 0L7 9m5-5l5 5"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <div class="pud-dropzone-title">Drag &amp; drop your file here</div>
    <div class="pud-dropzone-sub">
      or
      <button type="button" class="pud-browse" (click)="fileInput.click()">
        browse
      </button>
      to choose a file
    </div>
    <div class="pud-dropzone-hint">Accepted format: .xlsx</div>
  </div>

  <div class="pud-format">
    <div class="pud-format-title">Expected file format</div>
    <p class="pud-format-desc">
      The <strong>first column must be ISIN</strong>,
      <strong>second column must be Weight</strong>. A header row is optional.
    </p>
    <table class="pud-format-table">
      <thead>
        <tr>
          <th>ISIN</th>
          <th>Weight</th>
          <th>…</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>US0378331005</td>
          <td>0.25</td>
          <td></td>
        </tr>
        <tr>
          <td>GB0002634946</td>
          <td>0.15</td>
          <td></td>
        </tr>
        <tr>
          <td>DE0005140008</td>
          <td>0.60</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button type="button" class="pud-cancel" (click)="onCancel()">Cancel</button>
</div>
